import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SHARED_MODULES } from '../../../shared.';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['./time-picker.component.scss'],
	imports: [SHARED_MODULES, FaIconComponent],
    standalone: true
})
export class TimePickerComponent implements OnInit {

	numbers1to12: Array<any>;
	numbers13to24: Array<any>;
	minutesOn5: Array<any>;
	showPicker: boolean = false;
	clockHour: boolean = true;
	clockMinutes: boolean = false;
	@Input() onlyHour: boolean = false;
	hour = '09';
	minute = '00';
	inputTime = '';
	top: number;
	left: number;
	id: string;
	clickEv: boolean = false;
	@ViewChild('timepicker') timepicker: ElementRef;
	time: string;
	@Output() setTime = new EventEmitter<any>();

	constructor(private _eref: ElementRef) {
	}

	@Input('id')
	set setId(value) {
		this.id = value;
	}

	@Input('top')
	set setTop(value) {
		this.top = value;
	}

	@Input('left')
	set setLeft(value) {
		this.left = value;
	}

	@Input('time')
	set Time(value) {
		this.hour = String(value.split(':')[0]);
		this.minute = String(value.split(':')[1]);
		this.ngOnInit();

	}

	updateInput() {
		this.inputTime = this.hour + ':' + this.minute;
	}

	ngOnInit() {
		this.numbers1to12 = Array(12).fill(null).map((x, i) => {
			let value = String(i + 1),
				view = (value.length > 1) ? value : '0' + value;
			return {
				view: view,
				active: false
			};
		});
		this.numbers13to24 = Array(12).fill(null).map((x, i) => {
			let value = String(i + 13),
				view = value;
			if (value == '24') view = value = '00';
			return {
				view: view,
				active: false
			};
		});

		this.minutesOn5 = Array(12).fill(null).map((x, i) => {
			let value = String(i * 5),
				view = (value.length > 1) ? value : '0' + value;
			return {
				view: view,
				active: false
			};
		});

		this.checkHour(this.hour);
		this.checkMinute(this.minute);
		this.updateInput();
	}

	checkHour(value) {
		this.numbers1to12.forEach(i => {
			this.hour = (i.view == value) ? i.view : this.hour;
			i.active = (i.view == value);

		});
		this.numbers13to24.forEach(i => {
			this.hour = (i.view == value) ? i.view : this.hour;
			i.active = (i.view == value);
		});
		if (this.onlyHour) {
			this.save();
		}
		this.showMinute();
	}

	checkMinute(value) {
		this.minutesOn5.forEach(i => {
			i.active = (i.view == value);
			this.minute = (i.view == value) ? i.view : this.minute;
		});
		this.save();
	}

	save() {
		this.showPicker = false;
		this.updateInput();
		this.setTime.emit(this.hour + ':' + this.minute);
	}

	cancel() {
		this.showPicker = false;
		this.hour = String(this.inputTime.split(':')[0]);
		this.minute = String(this.inputTime.split(':')[1]);
		this.checkHour(this.hour);
		this.checkMinute(this.minute);
	}

	activate() {
		this.showHour();
		this.showPicker = true;
		setTimeout(() => {
			let elem = this.timepicker.nativeElement,
				coord = elem.getBoundingClientRect();
			if (window.innerWidth - coord.right < 0) {
				elem.style.left = -coord.width + 'px';
			}
			if (coord.top < 0) {
				elem.style.top = 0 + 'px';
			}
			if (window.innerHeight - coord.bottom < 0) {
				elem.style.top = window.innerHeight - coord.bottom - 50 + 'px';
			}
		});

	}

	showHour() {
		this.clockHour = true;
		this.clockMinutes = false;
	}

	showMinute() {
		this.clockHour = false;
		this.clockMinutes = true;
	}

	@HostListener('window:click', ['$event'])
	pageClick(event) {
		if (this.clickEv) {
			this.clickEv = false;
			return;
		}
		if (!this._eref.nativeElement.contains(event.target)) this.cancel();

	}

}
